'use client';

/**
 * Inline "the last reply failed" row with a Retry action.
 *
 * Per the ERROR_STATES_ACTIONABLE rule, a failed generation must offer the fix
 * in place rather than silently vanish. Rendered when `useChat` status is
 * 'error'; Retry calls `regenerate()`, which re-runs the last user turn and
 * preserves chat state.
 */

interface ChatErrorRetryProps {
  error?: Error;
  onRetry: () => void;
}

export function ChatErrorRetry({ error, onRetry }: ChatErrorRetryProps) {
  return (
    <div
      role="alert"
      className="mx-auto w-full max-w-3xl px-4 py-3 my-2 flex items-center justify-between gap-4 rounded-lg border border-destructive/30 bg-destructive/10 text-destructive"
    >
      <p className="text-sm font-medium">
        {error?.message
          ? `Something went wrong generating a reply: ${error.message}`
          : 'Something went wrong generating a reply.'}
      </p>
      <button
        type="button"
        onClick={onRetry}
        className="flex-shrink-0 min-h-11 px-4 py-2 text-sm font-medium rounded bg-destructive text-destructive-foreground hover:opacity-90 transition-opacity"
      >
        Retry
      </button>
    </div>
  );
}
